import { generateID } from "@digitallab/grid-common-frontend-components";
import { OwcDatepicker } from "@one/react";
import { useField } from "formik";
import ACTION_LOGS_DATA_MODEL from "../../../../utils/constants/actionLogsDataModel";
import { Module } from "../../../../constants";

import type { OwcDatepickerCustomEvent } from "@one/web-components/dist/types/components";
import { react18WorkaroundProps } from "../../../../utils/constants/react18WorkaroundProps";

export const ActionDateInput = () => {
  const [field, meta, { setValue }] = useField("actionDate");
  const dateValue = (event: OwcDatepickerCustomEvent<any>) => {
    const date = event.detail;
    // OwcDatepicker can emit empty string when cleared via the cross icon.
    // Treat that as an explicit clear and force validation refresh.
    if (date === "" || date === null || date === undefined) {
      setValue(undefined, true);
      return;
    }

    if (date instanceof Date) {
      setValue(date, true);
      return;
    }

    // Fallback for unexpected payload types to avoid stale valid date state.
    setValue(undefined, true);
  };

  return (
    <OwcDatepicker
      style={{ width: "100%" }}
      autoClose
      onBlur={field.onBlur}
      format="dd-MMM-yyyy"
      data-testid="action-data-inputs-action-date-input"
      id={generateID.UUID(Module.POPUP_FIELDS.actionDate, 1, "datePicker")}
      name="actionDate"
      variant="filled"
      maxDate={new Date().getTime()}
      label={`${ACTION_LOGS_DATA_MODEL.actionDate.value} *`}
      value={typeof field.value === "string" ? new Date(field.value) : field.value}
      onValueChange={dateValue}
      invalidDateMessage={"Invalid date format"}
      required={true}
      requiredDateMessage={meta.error}
      {...react18WorkaroundProps}
    >
      {meta.error && <span slot="error-text">{meta.error}</span>}
    </OwcDatepicker>
  );
};
